var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelecom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2418 2.20961C18.6009 2.56899 18.8025 3.05621 18.8025 3.5642C18.8025 4.07219 18.6009 4.55941 18.2418 4.9188L15.87 7.29257C15.7801 7.3824 15.6583 7.43286 15.5312 7.43286C15.4041 7.43286 15.2823 7.3824 15.1924 7.29257L13.1598 5.25996C13.07 5.1701 13.0195 5.04825 13.0195 4.92119C13.0195 4.79413 13.07 4.67228 13.1598 4.58242L15.5317 2.20961C15.8911 1.85029 16.3785 1.64844 16.8868 1.64844C17.395 1.64844 17.8824 1.85029 18.2418 2.20961Z",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38191 16.1016C6.47174 16.1915 6.52221 16.3133 6.52221 16.4404C6.52221 16.5675 6.47174 16.6893 6.38191 16.7792L4.01006 19.152C3.65054 19.5114 3.16298 19.7132 2.65464 19.7131C2.1463 19.713 1.65882 19.511 1.29943 19.1515C0.940043 18.792 0.738191 18.3044 0.738281 17.7961C0.738371 17.2878 0.940395 16.8003 1.29991 16.4409L3.67177 14.07C3.76162 13.9802 3.88348 13.9297 4.01054 13.9297C4.13759 13.9297 4.25945 13.9802 4.3493 14.07L6.38191 16.1016Z",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3964 8.30803C6.9958 8.7085 6.67802 9.18397 6.46121 9.70727C6.2444 10.2306 6.13281 10.7915 6.13281 11.3579C6.13281 11.9243 6.2444 12.4852 6.46121 13.0085C6.67802 13.5318 6.9958 14.0073 7.3964 14.4078L13.4952 8.30803C13.0947 7.90758 12.6193 7.58992 12.0961 7.37319C11.5729 7.15647 11.0121 7.04492 10.4458 7.04492C9.87947 7.04492 9.31869 7.15647 8.79547 7.37319C8.27226 7.58992 7.79685 7.90758 7.3964 8.30803Z",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8194 9.98438C12.1847 10.3534 12.3933 10.8493 12.4015 11.3684C12.4097 11.8876 12.2169 12.3899 11.8635 12.7702C11.4847 13.1204 10.9844 13.3091 10.4687 13.2964C9.95305 13.2837 9.46264 13.0706 9.10156 12.7022",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6439 10.1133C14.754 10.8518 14.6899 11.6058 14.4568 12.3152C14.2237 13.0246 13.8281 13.6697 13.3014 14.199C12.7748 14.7283 12.1318 15.1273 11.4236 15.364C10.7154 15.6007 9.96174 15.6686 9.22266 15.5623",
    stroke: "#9B90A7",
    strokeWidth: 0.719995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5233 9.96875C17.6509 11.1126 17.5194 12.2705 17.1384 13.3566C16.7574 14.4427 16.1368 15.429 15.3226 16.2425C14.5084 17.056 13.5215 17.6757 12.4351 18.0557C11.3486 18.4356 10.1906 18.5661 9.04688 18.4375",
    stroke: "#9B90A7",
    strokeWidth: 0.719995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2917 8.97852C20.5849 10.6407 20.4749 12.349 19.9709 13.9599C19.467 15.5708 18.5838 17.0372 17.3956 18.2359C16.2074 19.4347 14.7488 20.3307 13.1424 20.8489C11.536 21.367 9.82878 21.492 8.16406 21.2135",
    stroke: "#9B90A7",
    strokeWidth: 0.719995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecom);
export default __webpack_public_path__ + "static/media/telecom.65a80bafdaf5685c3ba533248f33df1e.svg";
export { ForwardRef as ReactComponent };